// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/vc/request/conversation/create.proto (package qliq_protobuf.apps.vc.request.conversation, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { LocalizedEntity } from "../../../../localized_entity_pb.ts";
import { PhoneNumber } from "../../phone_number_pb.ts";
import { EmrType } from "../../../emr_type_pb.ts";

/**
 * @generated from message qliq_protobuf.apps.vc.request.conversation.Create
 */
export class Create extends Message<Create> {
  /**
   * @generated from field: qliq_protobuf.apps.vc.request.conversation.Create.Data data = 1;
   */
  data?: Create_Data;

  constructor(data?: PartialMessage<Create>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.request.conversation.Create";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "message", T: Create_Data },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Create {
    return new Create().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Create {
    return new Create().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Create {
    return new Create().fromJsonString(jsonString, options);
  }

  static equals(a: Create | PlainMessage<Create> | undefined, b: Create | PlainMessage<Create> | undefined): boolean {
    return proto3.util.equals(Create, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.apps.vc.request.conversation.Create.InviteSource
 */
export enum Create_InviteSource {
  /**
   * @generated from enum value: INVITE_VIA_UNKNOWN = 0;
   */
  INVITE_VIA_UNKNOWN = 0,

  /**
   * @generated from enum value: INVITE_VIA_SMS = 1;
   */
  INVITE_VIA_SMS = 1,

  /**
   * @generated from enum value: INVITE_VIA_EMAIL = 2;
   */
  INVITE_VIA_EMAIL = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Create_InviteSource)
proto3.util.setEnumType(Create_InviteSource, "qliq_protobuf.apps.vc.request.conversation.Create.InviteSource", [
  { no: 0, name: "INVITE_VIA_UNKNOWN" },
  { no: 1, name: "INVITE_VIA_SMS" },
  { no: 2, name: "INVITE_VIA_EMAIL" },
]);

/**
 * @generated from message qliq_protobuf.apps.vc.request.conversation.Create.EmailInvite
 */
export class Create_EmailInvite extends Message<Create_EmailInvite> {
  /**
   * @generated from field: qliq_protobuf.LocalizedEntity saved_email_subject = 1;
   */
  savedEmailSubject?: LocalizedEntity;

  /**
   * @generated from field: qliq_protobuf.LocalizedEntity saved_email_body = 2;
   */
  savedEmailBody?: LocalizedEntity;

  constructor(data?: PartialMessage<Create_EmailInvite>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.request.conversation.Create.EmailInvite";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "saved_email_subject", kind: "message", T: LocalizedEntity },
    { no: 2, name: "saved_email_body", kind: "message", T: LocalizedEntity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Create_EmailInvite {
    return new Create_EmailInvite().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Create_EmailInvite {
    return new Create_EmailInvite().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Create_EmailInvite {
    return new Create_EmailInvite().fromJsonString(jsonString, options);
  }

  static equals(a: Create_EmailInvite | PlainMessage<Create_EmailInvite> | undefined, b: Create_EmailInvite | PlainMessage<Create_EmailInvite> | undefined): boolean {
    return proto3.util.equals(Create_EmailInvite, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.vc.request.conversation.Create.SmsInvite
 */
export class Create_SmsInvite extends Message<Create_SmsInvite> {
  /**
   * @generated from field: qliq_protobuf.LocalizedEntity saved_sms_subject = 1;
   */
  savedSmsSubject?: LocalizedEntity;

  constructor(data?: PartialMessage<Create_SmsInvite>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.request.conversation.Create.SmsInvite";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "saved_sms_subject", kind: "message", T: LocalizedEntity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Create_SmsInvite {
    return new Create_SmsInvite().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Create_SmsInvite {
    return new Create_SmsInvite().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Create_SmsInvite {
    return new Create_SmsInvite().fromJsonString(jsonString, options);
  }

  static equals(a: Create_SmsInvite | PlainMessage<Create_SmsInvite> | undefined, b: Create_SmsInvite | PlainMessage<Create_SmsInvite> | undefined): boolean {
    return proto3.util.equals(Create_SmsInvite, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.vc.request.conversation.Create.PatientData
 */
export class Create_PatientData extends Message<Create_PatientData> {
  /**
   * @generated from field: string last_name = 1;
   */
  lastName = "";

  /**
   * @generated from field: repeated qliq_protobuf.apps.vc.PhoneNumber phone_list = 2;
   */
  phoneList: PhoneNumber[] = [];

  /**
   * @generated from field: map<string, string> meta_info = 3;
   */
  metaInfo: { [key: string]: string } = {};

  /**
   * TODO convert it to
   * repeated CustomAttribute custom_attributes = 4;
   *
   * @generated from field: map<string, string> custom_attributes = 4;
   */
  customAttributes: { [key: string]: string } = {};

  /**
   * @generated from field: string dob = 5;
   */
  dob = "";

  /**
   * @generated from field: string full_name = 6;
   */
  fullName = "";

  /**
   * @generated from field: string first_name = 7;
   */
  firstName = "";

  /**
   * @generated from field: string middle_name = 8;
   */
  middleName = "";

  /**
   * @generated from field: string mrn = 9;
   */
  mrn = "";

  /**
   * @generated from field: string mobile_number = 10;
   */
  mobileNumber = "";

  /**
   * @generated from field: string email = 11;
   */
  email = "";

  constructor(data?: PartialMessage<Create_PatientData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.request.conversation.Create.PatientData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone_list", kind: "message", T: PhoneNumber, repeated: true },
    { no: 3, name: "meta_info", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "custom_attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 5, name: "dob", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "middle_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "mrn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "mobile_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Create_PatientData {
    return new Create_PatientData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Create_PatientData {
    return new Create_PatientData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Create_PatientData {
    return new Create_PatientData().fromJsonString(jsonString, options);
  }

  static equals(a: Create_PatientData | PlainMessage<Create_PatientData> | undefined, b: Create_PatientData | PlainMessage<Create_PatientData> | undefined): boolean {
    return proto3.util.equals(Create_PatientData, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.vc.request.conversation.Create.Data
 */
export class Create_Data extends Message<Create_Data> {
  /**
   * @generated from field: uint32 chat_widget_id = 1;
   */
  chatWidgetId = 0;

  /**
   * @generated from field: uint32 patient_id = 2;
   */
  patientId = 0;

  /**
   * @generated from field: qliq_protobuf.apps.EmrType emr_type = 3;
   */
  emrType = EmrType.QLIQ;

  /**
   * @generated from field: bool is_private = 4;
   */
  isPrivate = false;

  /**
   * @generated from field: bool is_humans_only = 5;
   */
  isHumansOnly = false;

  /**
   * @generated from field: string reason_of_visit = 6;
   */
  reasonOfVisit = "";

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity custom_welcome_message = 7;
   */
  customWelcomeMessage: LocalizedEntity[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.apps.vc.request.conversation.Create.InviteSource invite_source = 8;
   */
  inviteSource: Create_InviteSource[] = [];

  /**
   * @generated from field: qliq_protobuf.apps.vc.request.conversation.Create.EmailInvite email_invite = 9;
   */
  emailInvite?: Create_EmailInvite;

  /**
   * @generated from field: qliq_protobuf.apps.vc.request.conversation.Create.SmsInvite sms_invite = 10;
   */
  smsInvite?: Create_SmsInvite;

  /**
   * @generated from field: bool send_invites_separately = 11;
   */
  sendInvitesSeparately = false;

  /**
   * @generated from field: qliq_protobuf.apps.vc.request.conversation.Create.PatientData patient_data = 12;
   */
  patientData?: Create_PatientData;

  /**
   * @generated from field: optional uint32 bot_design_id = 13;
   */
  botDesignId?: number;

  constructor(data?: PartialMessage<Create_Data>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.request.conversation.Create.Data";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chat_widget_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "patient_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "emr_type", kind: "enum", T: proto3.getEnumType(EmrType) },
    { no: 4, name: "is_private", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_humans_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "reason_of_visit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "custom_welcome_message", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 8, name: "invite_source", kind: "enum", T: proto3.getEnumType(Create_InviteSource), repeated: true },
    { no: 9, name: "email_invite", kind: "message", T: Create_EmailInvite },
    { no: 10, name: "sms_invite", kind: "message", T: Create_SmsInvite },
    { no: 11, name: "send_invites_separately", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "patient_data", kind: "message", T: Create_PatientData },
    { no: 13, name: "bot_design_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Create_Data {
    return new Create_Data().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Create_Data {
    return new Create_Data().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Create_Data {
    return new Create_Data().fromJsonString(jsonString, options);
  }

  static equals(a: Create_Data | PlainMessage<Create_Data> | undefined, b: Create_Data | PlainMessage<Create_Data> | undefined): boolean {
    return proto3.util.equals(Create_Data, a, b);
  }
}

